module.exports = __webpack_public_path__ + "img/help12.8e71fa4b.png";